export interface IpresentationStateAction {
    type: string;
    index: string;
    value: any;
}

export const changeShowFullScreenLink = (data: boolean) => ({
    type: 'SHOW_FULL_SCREEN_LINK',
    value: data,
});

export const currentSlideIndex = (data: number) => ({
    type: 'CURRENT_SLIDE_INDEX',
    value: data,
});

export const slideCount = (data: number) => ({
    type: 'SLIDE_COUNT',
    value: data,
});

export const presentationHTMLFragments = (index: string, data: string) => ({
    type: 'PRESENTATION_HTML_FRAGMENTS',
    index,
    value: data,
});

export const presentationJSONFragments = (index: string, data: JSON) => ({
    type: 'PRESENTATION_JSON_FRAGMENTS',
    index,
    value: data,
});

export const changeSlideHeight = (data: number) => ({
    type: 'CHANGE_SLIDE_HEIGHT',
    value: data,
});

export const changeSlideZoom = (data: object) => ({
    type: 'CHANGE_SLIDE_ZOOM',
    value: data,
});

export const changeModalStatus = (data: boolean) => ({
    type: 'CHANGE_MODAL_STATUS',
    value: data,
});

export const changeSlideBaseWidth = (data: number) => ({
    type: 'CHANGE_SLIDE_BASE_WIDTH',
    value: data,
});

export const changeSlideBaseHeight = (data: number) => ({
    type: 'CHANGE_SLIDE_BASE_HEIGHT',
    value: data,
});

export const changeBodySource = (data: any) => ({
    type: 'CHANGE_BODY_SOURCE',
    value: data,
});
